import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import DragIndicator  from "@material-ui/icons/DragIndicator";
import CompanyProductMoveDialog from "./CompanyProductMoveDialog";
import {
  IconButton,
  Button
} from "@material-ui/core";


const useStyles = makeStyles((theme) => ({
 
}));



export default function ButtonMoveBProduct({ item, moveItem, projectId }) {
  const classes = useStyles();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOnOpen = () => {
    setIsDialogOpen(true);
  };
  const handleOnClose = () => {
    setIsDialogOpen(false);
  }; 
  const doMoveItem=()=>{
    setIsDialogOpen(false);
    moveItem&&moveItem()
  }
  return (
    <>
      {item&&(
        <IconButton onClick={handleOnOpen} title={`Move/change group for ${item.productMatchingGroup.id}`}>
          <DragIndicator/>
        </IconButton>      
      )}      
      <CompanyProductMoveDialog
        open={isDialogOpen}
        onClose={handleOnClose}
        item = {item}
        doMoveItem={doMoveItem}
        projectId={projectId}
      />
    </>
  );
}
